import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Table
} from 'reactstrap';

import Customer from '../Customer';
import { PaginationWrapper } from '../Components'

const Customers = props => {
  const renderOrganisation = customer => {
    return <Customer 
      key={ customer.id } 
      isOpen={ props.isOpen }
      customer={ customer } 
      selectedCustomer={ props.selectedCustomer } 
      customerLoading={ props.customerLoading }
      customerError={ props.customerError }
      updateCustomer={ props.updateCustomer }
      onChangeStatus={ props.onChangeStatus }
      onSelectCustomer={ props.onSelectCustomer }
      toggleModal={ props.toggleModal }
    />;
  };
  return (
    <div className="animated fadeIn">
      <Card>
        <CardHeader>
          Traffic {' & '} Clients
        </CardHeader>
        <CardBody>
          <Table hover responsive className="table-outline d-none d-sm-table">
            <thead className="thead-light">
              <tr>
                <th className="text-center"><i className="icon-people"></i></th>
                <th>Name</th>
                <th className="text-center">Identifier</th>
                <th>Primary email</th>
                <th className="text-center">Contact telephone</th>
                <th className="text-center">Users limit</th>
                <th className="text-center">Users Count</th>
                <th className="text-center">Status</th>
              </tr>
            </thead>
            <tbody>{ props.customers.map(renderOrganisation)}</tbody>                  
          </Table>
          { props.meta.count > props.meta.limit && 
            <PaginationWrapper  loadCustomers={ props.loadCustomers } meta={ props.meta }/> }
        </CardBody>
      </Card>  
    </div>
  );
}

export default Customers;



// WEBPACK FOOTER //
// ./src/views/Customers/Customers.js